import { render, staticRenderFns } from "./RegistryFormDataViewer.vue?vue&type=template&id=8c753a8c&scoped=true&"
import script from "./RegistryFormDataViewer.vue?vue&type=script&lang=js&"
export * from "./RegistryFormDataViewer.vue?vue&type=script&lang=js&"
import style0 from "./RegistryFormDataViewer.vue?vue&type=style&index=0&id=8c753a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c753a8c",
  null
  
)

export default component.exports